(function () {
    Titania = typeof (Titania) != "undefined" && Titania || {};
    Titania.Functions = Titania.Functions || {};

    Titania.Functions.IsValidEmail = function (emailAddress) {
        //below regex was taken from top answer in https://stackoverflow.com/questions/46370725/how-to-do-email-validation-using-regular-expression-in-typescript
        return emailAddress && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(emailAddress);
    }
})();